





import Vue from 'vue'
export default Vue.extend({
  props: {
    noMargin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    num () {
      // @ts-ignore
      return this.$store.getters['resp/blankRespNum']
    }
  }
})
